<template>
  <div id="app" >
    <router-view/>
  </div>
</template>

<script >
  export default {
    name: 'App'
  }
</script>

<style>
  #app{
    width: 100%;
    height: 100%;
    min-width: 1260px;
    /* overflow-y: hidden */

  }
  .el-icon-caveat {
		width: 50px;
		height: 50px;
		background: url(assets/img/warning.png) center no-repeat;
		background-size: cover;
	}
</style>